import { render, staticRenderFns } from "./DhlShipmentForm.vue?vue&type=template&id=42c7f5c6&"
import script from "./DhlShipmentForm.vue?vue&type=script&lang=js&"
export * from "./DhlShipmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports